
import { createRef, useContext, useEffect, useMemo, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {getUUID, Loading, PaginatedTable, TBD } from '../common/variables';
import { ClubContext } from '../context/club';


//material-ui
import AddIcon from '@material-ui/icons/Add';
import FileIcon from '@material-ui/icons/DescriptionOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadIcon from '@material-ui/icons/PublishOutlined';
import { IconButton } from '@material-ui/core';
import { AppContext } from '../context/app';

export default function Clubs(){
    const { showAppToast , hideAppToast,  } = useContext(AppContext);
    const { clubState : {clubs} , getClubs , addClub , removeClub} = useContext(ClubContext);
    const [DataLoading , setDataLoading] = useState(true);
    useEffect(()=>{
      try{
        getClubs();
      }
      finally{
        setTimeout(()=>setDataLoading(false) ,1000);
      }
    },[]);
    async function handleClubsRefresh(){
      try{
        setDataLoading(true);
        getClubs();
      }
      finally{
        setTimeout(()=>setDataLoading(false) ,1000);
      }
    }
    const [isAddingClub , setAddingClub] = useState(false);
    const [name , setNewClubName] = useState("");
    const [newClubOrganizationType , setNewClubOrganizationType] = useState("club");
    const [uploadFileName , setUploadName] = useState("");
    const [uploadClubs , setClubsToUpload] = useState([]);
    const [completed , setCompleted ] = useState(0);
    const [failed , setFailed ] = useState(0);
    const [loading , setLoading ] = useState(0);
    const [uploading , setUpLoading ] = useState(false);
    const [organization_type , setOrganizationType ] = useState("");
    const [perPage , setPerPage] = useState(10);
    const [validatingDelete , setValidatingDelete] = useState(false);
    const [clubToDelete , setClubToDelete] = useState(null);

    const selected_clubs = useMemo(()=>{
      clubs.sort((a,b)=>a.name < b.name ? -1 : 1);
      if(!organization_type){
        return clubs;
      }
      return clubs.filter((club)=>  club.organization_type === organization_type);
    },[clubs , organization_type]);

    let inputRef = createRef();
    function handleFileUpload(e){
      const file = e.target.files[0];
      setUploadName(file.name);
      const fr = new FileReader();
      fr.onload = function(){
        setClubsToUpload(fr.result.split("\n"));
      };
      fr.readAsText(file);
    }
    async function handleClubUpload(){
      const id = getUUID();
      try{
        await addClub({name , id , organization_type : newClubOrganizationType});
        showAppToast(`${name} added`,"success");
      }
      catch(err){
        showAppToast(`Error when adding ${name}`,"error");
        console.log(err);
      }
      finally{
        setTimeout(()=>hideAppToast(),1000);
        setAddingClub(false);
        setNewClubName("");
        setNewClubOrganizationType("club");
      }
    }
    async function handleClubDelete(){
      try{
        await removeClub({id : clubToDelete.id});
        showAppToast(`${clubToDelete.name} deleted`,"success");
      }
      catch(err){
        showAppToast(`Error when deleting ${clubToDelete.name}`,"error");
        console.log(err);
      }
      finally{
        setTimeout(()=>hideAppToast(),1000);
        setValidatingDelete(false);
        setNewClubName("");
        setNewClubOrganizationType("club");
      }
    }
    async function handleBulkUpload(){
      setUpLoading(true);
      setLoading(uploadClubs.length- 1);
      let c = 0 , f = 0 , l = uploadClubs.length - 1 ;
      for(let name of uploadClubs){
        const id = getUUID();
        try{
          await addClub({name , id});
          setCompleted(c++);
        } catch(err){
          setFailed(f++);
        } finally{
          setLoading(l--);
        }
      }
    }
    return(
      <div className="mr-2 p-2 d-flex flex-column">
      <div className="d-flex mb-1 justify-content-between">
        <h4>Clubs</h4>
        <div className="d-flex align-items-center">
        <Form.Control  style={{width : 200 , marginRight : 4}} as="select" value={organization_type} onChange={(e)=>setOrganizationType(e.target.value)}>
          <option value="">--- Select Type ---</option>
          <option value="club">Club</option>
          <option value="school">School</option>
        </Form.Control>
        <Form.Control  style={{width : 100 , marginRight : 4}} as="select" value={perPage} onChange={(e)=>setPerPage(e.target.value)}>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
        </Form.Control>
          {
            uploading && 
            <ProgressBar style={{width : 200 , marginRight : 10}}>
              <ProgressBar striped variant="success" now={completed * 100 / uploadClubs.length-1} key={1} />
              <ProgressBar striped variant="danger" now={failed * 100 / uploadClubs.length-1} key={2} />
              <ProgressBar variant="warning" now={loading * 100 / uploadClubs.length-1} key={3} />
            </ProgressBar>
          }
          <input ref={(ref)=> inputRef =  ref } type="file" accept="text/txt" id="file-upload" style={{display : "none"}}  onChange={handleFileUpload}/>
          <div className="mr-2"><p className="mb-0 text-muted"><strong>{uploadFileName}</strong></p></div>
          {
            uploadFileName ?
            <Button size="sm" className="mr-2" onClick={handleBulkUpload}><UploadIcon/></Button> :
            <Button size="sm" onClick={()=>inputRef.click()} className="mr-2"><FileIcon/></Button>
          }
          <Button size="sm" className="mr-2" onClick={()=>setAddingClub(true)} ><AddIcon/></Button>
          <Button size="sm" variant="outline-success"  onClick={handleClubsRefresh} ><RefreshIcon/></Button>
        </div>
      </div>
      {
        DataLoading ? <Loading/> :
          <PaginatedTable striped bordered
            thead={
              <tr>
                {TBD && <th style={{width : 50}}/>}
                <th style={{width : 200}}>Name</th>
                <th style={{width : 100}}>Type</th>
                <th style={{width : 100}}>Number of Athletes</th>
                <th style={{width : 100}}>Number of Coaches</th>
                <th style={{width : 100}}>Created Date</th>
                <th style={{width : 40}}/>
              </tr>}
            renderEmpty={<tr><td style={{textAlign : "center" , padding : 8}} colSpan={7}>No clubs</td></tr>}
            renderRowAs={({item:club})=>{
              return (
                <tr key={club.id}>
                  {TBD &&<td><Form.Check type="checkbox"/></td>}
                  <td>{club.name}</td>
                  <td>{`${club.organization_type[0].toUpperCase()}${club.organization_type.slice(1)}`}</td>
                  <td>{club.organization_type === "club" ? club.athletes.items.length  : (club.organization_type === "school" ?  club.school_athletes.items.length : 0)}</td>
                  <td>{club.coaches.items  ? club.coaches.items.length : 0}</td>
                  <td>{club.createdAt.split('T')[0]}</td>
                  <td style={{textAlign : "center"}}>
                    {TBD && <Button size="sm" className="ml-1" variant="outline-warning"><EditIcon style={{fontSize :"1rem"}}/></Button>}
                    <IconButton className="p-0 ml-1 text-danger"><DeleteIcon style={{fontSize :"1rem"}} onClick={()=>{setClubToDelete(club);setValidatingDelete(true)}}/></IconButton>
                  </td>
                </tr>
              )
            }}
            perPage={perPage}
            items={selected_clubs}
            />
      }
      {validatingDelete && clubToDelete &&
          <Modal show>
            <Modal.Header closeButton onHide={()=>setValidatingDelete(false)}>
                <Modal.Title>{`Delete ${clubToDelete.organization_type}`}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>You have chosen to delete the {clubToDelete.organization_type} <strong>{clubToDelete.name}</strong>. This action cannot be undone.</p>
                <p>Do you wish to continue?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={()=>setValidatingDelete(false)}>
                  Close
                </Button>
                <Button variant="danger" onClick={handleClubDelete}>Delete</Button>
              </Modal.Footer>
          </Modal>
    }
      <Modal show={isAddingClub}>
        <Modal.Header closeButton onHide={()=>setAddingClub(false)}>
            <Modal.Title>Add New Club</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Col}  >
                  <Form.Label style={{display : "flex"}}><p style={{marginBottom : 0}}>Name</p></Form.Label>
                  <Form.Control type="text" onChange={(e)=>{setNewClubName(e.target.value)}} value={name}/>
              </Form.Group>
              <Form.Group as={Col}  >
                  <Form.Label style={{display : "flex"}}><p style={{marginBottom : 0}}>Type</p></Form.Label>
                  <Form.Control as="select" onChange={(e)=>{setNewClubOrganizationType(e.target.value)}} value={newClubOrganizationType}>
                    <option value="club" label="Club"/>
                    <option value="school" label="School"/>
                  </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>setAddingClub(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleClubUpload}>Upload</Button>
          </Modal.Footer>
      </Modal>
    </div>)
}